module.exports = __webpack_public_path__ + "img/ch9pic6.1d147fbc.png";